import { useQueries, useQuery } from "@tanstack/react-query";
import type { Agent, UsageRecord } from "@agentsaas/protocol";
import { useServices } from "../app/services";
import { qk, useProjects } from "./queries";

/** P6 计费数据：用量聚合 / 明细、钱包、账单 */

export const bk = {
  usage: (tid: string, q: object) => ["billing", tid, "usage", q] as const,
  records: (tid: string) => ["billing", tid, "records"] as const,
  wallet: (tid: string) => ["billing", tid, "wallet"] as const,
  invoices: (tid: string) => ["billing", tid, "invoices"] as const,
};

export function useUsage(tid: string, q: { from: string; to: string; groupBy: "agent" | "project" | "kind" | "day"; kind?: UsageRecord["kind"] }) {
  const { api } = useServices();
  return useQuery({ queryKey: bk.usage(tid, q), queryFn: () => api.call("usageQuery", { params: { tid }, query: q }), placeholderData: (prev) => prev });
}

export function useUsageRecords(tid: string) {
  const { api } = useServices();
  return useQuery({ queryKey: bk.records(tid), queryFn: async () => (await api.call("usageRecords", { params: { tid }, query: { limit: 20 } })).items });
}

/** pollMs：充值等待到账时轮询 */
export function useWallet(tid: string, pollMs?: number | false) {
  const { api } = useServices();
  return useQuery({ queryKey: bk.wallet(tid), queryFn: () => api.call("walletGet", { params: { tid } }), refetchInterval: pollMs || false });
}

export function useInvoices(tid: string) {
  const { api } = useServices();
  return useQuery({ queryKey: bk.invoices(tid), queryFn: async () => (await api.call("invoiceList", { params: { tid }, query: { limit: 50 } })).items });
}

/** 租户下所有项目的 agent（用量按 agent 分组时显示名字） */
export function useTenantAgents(tid: string): Agent[] {
  const { api } = useServices();
  const projects = useProjects(tid).data ?? [];
  const qs = useQueries({
    queries: projects.map((p) => ({ queryKey: qk.agents(p.id), queryFn: async () => (await api.call("agentList", { params: { pid: p.id } })).items })),
  });
  return qs.flatMap((q) => q.data ?? []);
}
